import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=5d0ffbd3&scoped=true"
import script from "./datepicker.vue?vue&type=script&lang=js"
export * from "./datepicker.vue?vue&type=script&lang=js"
import style0 from "./datepicker.vue?vue&type=style&index=0&id=5d0ffbd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ffbd3",
  null
  
)

export default component.exports